export const enum SiteTypeEnum {
  None = 0,
  ExistingBuilding = 1,
  Land = 2,
}
